var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgAskADemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#EBF2FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.949 14.023c0-.523-.209-1.025-.58-1.395a1.981 1.981 0 0 0-1.398-.577H13.079a1.975 1.975 0 0 0-1.979 1.972v10.7a1.975 1.975 0 0 0 1.98 1.971h.772v3.344l3.808-3.306h11.321a1.988 1.988 0 0 0 1.904-1.44c.05-.174.074-.353.074-.532l-.01-10.737Z",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.781 22.808v-.154a6.682 6.682 0 0 0-1.864-4.774 6.728 6.728 0 0 0-9.495-.203 6.683 6.683 0 0 0-2.068 4.69v.277a6.686 6.686 0 0 0 1.952 4.627 6.731 6.731 0 0 0 9.336.189 6.688 6.688 0 0 0 2.14-4.545.82.82 0 0 0 0-.107v0Z",
    fill: "#EBF2FB",
    stroke: "#3D82F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.046 23.686a.926.926 0 0 0 .928-.925.926.926 0 0 0-.928-.925.926.926 0 0 0-.928.925c0 .51.415.925.928.925Zm4.692-4.582-3.93 3.066m-.778-6.35v-1.287m2.277 0h-4.549",
    stroke: "#050505",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskADemo);
export default __webpack_public_path__ + "static/media/AskADemo.2388f8c05385589f1c8079c75014f317.svg";
export { ForwardRef as ReactComponent };